export default "__VITE_ASSET__PQjNypvc__"